import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M16 4H9a3 3 0 0 0-2.83 4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M14 12a4 4 0 0 1 0 8H6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "4", x2: "20", y1: "12", y2: "12", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Strikethrough";
const Strikethrough = memo(themed(Icon));
export {
  Strikethrough
};
//# sourceMappingURL=strikethrough.js.map
